<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('OtherPlatform.View.Heading') }}</strong>
                </h4>
                <h4>
                    <strong>{{ $t('OtherPlatform.View.Heading2') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.ManagerName') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="contact_name === null || contact_name === null">N/A</p>
                        <p v-else>{{ contact_name }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.ManagerContact') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="contact_person_num === null || contact_person_num === null">N/A</p>
                        <p v-else>{{ contact_person_num }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.ManagerEmail') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="contact_email === null || contact_email === null">N/A</p>
                        <p v-else>{{ contact_email }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.CompanyAddress') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="business_address === null || business_address === null">N/A</p>
                        <p v-else>{{ business_address }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.DetailAddress') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="job_detail_address === null">N/A</p>
                        <p v-else>{{ job_detail_address }}</p>
                    </div>
                </div>
                <h4>
                    <strong>{{ $t('OtherPlatform.View.Heading3') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Gender') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="gender === null || gender === null">N/A</p>
                        <p v-else-if="gender === 'male'">{{ $t('male') }}</p>
                        <p v-else-if="gender === 'female'">{{ $t('female') }}</p>
                        <p v-else-if="gender === 'any'">{{ $t('any') }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Age') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <span v-if="start_age && end_age">
                            <p v-if="start_age === null && end_age === null">N/A</p>
                            <p v-else>{{ start_age }} ~ {{ end_age }}</p>
                        </span>
                        <span v-else>
                            <p v-if="age === 'any'">{{ $t('ANY') }}</p>
                        </span>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Education') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <!-- <p>{{ education === null ? 'N/A' : education }}</p> -->
                        <p v-if="education === 'elementary_school'">{{ $t('elementary_school') }}</p>
                        <p v-else-if="education === 'middle_school'">{{ $t('middle_school') }}</p>
                        <p v-else-if="education === 'high_school'">{{ $t('high_school') }}</p>
                        <p v-else-if="education === 'university_2_or_3_years'">{{ $t('university_2_or_3_years') }}</p>
                        <p v-else-if="education === 'university_4_years'">{{ $t('university_4_years') }}</p>
                        <p v-else-if="education === 'graduate_school'">{{ $t('graduate_school') }}</p>
                        <p v-else-if="education === 'no_academic_background'">{{ $t('no_academic_background') }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.jobselection') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <!-- <p v-html="mydata.content" id="desc"></p> -->
                        <!-- <Tag value="Primary" id="JS" v-for="(occupations, index) in occupations" :key="index">{{ occupations.name }}</Tag> -->
                        <i v-show="iconload" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                        <Tag v-show="hidefor" value="Primary" id="JS" v-for="item in occupations" :key="item">{{ item }}</Tag>
                        <!-- <Tag value="Primary" id="JS" v-for="(occupations, index) in occupations" :key="index">{{ occupations.occupation_second_txt }}</Tag>
                        <Tag value="Primary" id="JS" v-for="(occupations, index) in occupations" :key="index">{{ occupations.occupation_third_txt }}</Tag> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.preferentialconditions') }}:</label>
                    <div class="p-col-12 p-md-6 justify-content-center gap-2">
                        <!-- <Tag value="Primary">{{ getPreferentials }}</Tag> -->
                        <i v-show="iconload" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                        <Tag v-show="hidefor" value="Primary" id="PC" v-for="item in preferential_conditions" :key="item">{{ item }}</Tag>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Areaofrecruitment') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ areas_of_recruitment === null ? 'N/A' : areas_of_recruitment }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Noofrecruitment') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ num_of_recruitment === null ? 'N/A' : num_of_recruitment }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Responsibilities') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ responsibilities === null ? 'N/A' : responsibilities }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.elligibilities') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ eligibilities === null ? 'N/A' : eligibilities }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Career') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="career === 'experience'">{{ $t('experience') }}</p>
                        <p v-else-if="career === 'elementary'">{{ $t('elementary') }}</p>
                        <p v-else-if="career === 'intermediate'">{{ $t('intermediate') }}</p>
                        <p v-else-if="career === 'advanced'">{{ $t('advanced') }}</p>
                        <p v-else-if="career === 'newcomer'">{{ $t('newcomer') }}</p>
                        <p v-else-if="career === 'any'">{{ $t('any') }}</p>
                    </div>
                </div>
                <h4>
                    <strong>{{ $t('OtherPlatform.View.Heading4') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.WorkType') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="work_type === 'full_time'">{{ $t('full_time') }}</p>
                        <p v-else-if="work_type === 'contract_worker'">{{ $t('contract_worker') }}</p>
                        <p v-else-if="work_type === 'part_time_job'">{{ $t('part_time_job') }}</p>
                        <p v-else-if="work_type === 'dispatch'">{{ $t('dispatch') }}</p>
                        <p v-else-if="work_type === 'internship'">{{ $t('internship') }}</p>
                        <p v-else-if="work_type === 'freelancer'">{{ $t('freelancer') }}</p>
                        <p v-else-if="work_type === 'etc'">{{ $t('etc') }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Probation') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ probation === null ? 'N/A' : probation }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.WorkPeriod') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="working_period === '' || working_period === null">N/A</p>
                        <p v-else-if="working_period == '1_day'">{{ $t('1_day') }}</p>
                        <p v-else-if="working_period == '2_day'">{{ $t('2_day') }}</p>
                        <p v-else-if="working_period == '3_day'">{{ $t('3_day') }}</p>
                        <p v-else-if="working_period == '4_day'">{{ $t('4_day') }}</p>
                        <p v-else-if="working_period == '5_day'">{{ $t('5_day') }}</p>
                        <p v-else-if="working_period == '6_day'">{{ $t('6_day') }}</p>
                        <p v-else-if="working_period == '7_day'">{{ $t('7_day') }}</p>
                        <p v-else-if="working_period == '1_month_to_3_months'">{{ $t('1_month_to_3_months') }}</p>
                        <p v-else-if="working_period == '1_week_to_1_month'">{{ $t('1_week_to_1_month') }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.WorkingDay') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <!-- <p v-if="working_days.length === 0">No working days selected.</p> -->
                        <!-- <p v-if="working_days.length > 0">
                            {{ working_days.length }} {{ $t('Days') }} ~
                            <span v-if="working_days.length === 1">{{ weekdays[working_days[0] - 1] }}</span>
                            <span v-else> {{ weekdays[working_days[0] - 1] }} - {{ weekdays[working_days[working_days.length - 1] - 1] }} </span>
                        </p> -->
                        <p class="p-right" v-if="working_days.length == 7">{{ working_days.length }}일 (월,화,수,목,금,토,일)</p>
                        <p class="p-right" v-if="working_days.length == 6">{{ working_days.length }}일 (월,화,수,목,금,토)</p>
                        <p class="p-right" v-if="working_days.length == 5">{{ working_days.length }}일 (월,화,수,목,금)</p>
                        <p class="p-right" v-if="working_days.length == 4">{{ working_days.length }}일 (월,화,수,목)</p>
                        <p class="p-right" v-if="working_days.length == 3">{{ working_days.length }}일 (월,화,수)</p>
                        <p class="p-right" v-if="working_days.length == 2">{{ working_days.length }}일 (월,화)</p>
                        <p class="p-right" v-if="working_days.length == 1">{{ working_days.length }}일 (월)</p>
                        <p class="p-right" v-if="working_days.length == 0">요일협의</p>
                        <!-- <p v-for="item in working_days" :key="item">{{ item }}</p> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.WorkingHour') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} ~ {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}</p>
                        <!-- <input type="time" v-model="working_hour_from" class="timehello"> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.BreakTime') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="break_time_from === null && break_time_end === null">{{ $t('NoBreakTime') }}</p>
                        <p v-else>{{ break_time_from === 'NaN:NaN' ? '--' : break_time_from }} ~ {{ break_time_end === 'NaN:NaN' ? '--' : break_time_end }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.prescribedworkinghours') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ prescribed_working_hours }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.Pay') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="pay_type === '' || pay_type === null">N/A</p>
                        <p v-else-if="pay_type == 'daily_wage'">₩ {{ formatSalary(salary) }} {{ $t('Won') }} / {{ $t('daily_wage') }}</p>
                        <p v-else-if="pay_type == 'hourly_wage'">₩ {{ formatSalary(salary) }} {{ $t('Won') }} / {{ $t('hourly_wage') }}</p>
                        <p v-else-if="pay_type == 'salary'">₩ {{ formatSalary(salary) }} {{ $t('Won') }} / {{ $t('salary') }}</p>
                    </div>
                </div>
                <h4>
                    <strong>{{ $t('OtherPlatform.View.Heading6') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.AnnounceTitle') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ announcement_title }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.MainImage') }}:</label>
                    <div class="p-col-12 p-md-6" style="display: flex; justify-content: center; flex-wrap: wrap; width: fit-content; margin-left: -13px">
                        <div v-for="(background_pictures, index) in background_pictures" :key="index" style="margin: 5px">
                            <img :src="background_pictures.image_url" alt="이미지를 사용할 수 없음" class="product-image" v-if="background_pictures.type === 'thumbnail'" />
                        </div>
                        <!-- <p v-html="mydata.content" id="desc"></p> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.BGImage') }}:</label>
                    <div class="p-col-12 p-md-6" style="display: flex; justify-content: center; flex-wrap: wrap; width: fit-content; margin-left: -22px">
                        <div v-for="(background_pictures, index) in background_pictures" :key="index" style="margin: 5px">
                            <img :src="background_pictures.image_url" alt="이미지를 사용할 수 없음" class="product-image" v-if="background_pictures.type === 'background'" />
                        </div>
                        <!-- <p v-html="mydata.content" id="desc"></p> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.NoticePosting') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p v-if="notice_posting_period === '' || notice_posting_period === null">N/A</p>
                        <p v-else-if="notice_posting_period == '1_days'">{{ $t('1_days') }}</p>
                        <p v-else-if="notice_posting_period == '2_days'">{{ $t('2_days') }}</p>
                        <p v-else-if="notice_posting_period == '3_days'">{{ $t('3_days') }}</p>
                        <p v-else-if="notice_posting_period == '4_days'">{{ $t('4_days') }}</p>
                        <p v-else-if="notice_posting_period == '5_days'">{{ $t('5_days') }}</p>
                        <p v-else-if="notice_posting_period == '6_days'">{{ $t('6_days') }}</p>
                        <p v-else-if="notice_posting_period == '7_days'">{{ $t('7_days') }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.JobStartDate') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ dateformat(notice_posting_period_custom_start_date) }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">{{ $t('OtherPlatform.View.JobEndDate') }}:</label>
                    <div class="p-col-12 p-md-6">
                        <p>{{ dateformat(notice_posting_period_custom_end_date) }}</p>
                    </div>
                </div>

                <!-- <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                    <router-link @mouseenter="editnotice($route.params.update_key)" :to="'/ServiceTerms/EditServiceTerms/' + $route.params.update_key">
                        <Button :label="$t('notice1.view.Edit')" class="p-button1 p-button-outlined p-button p-mr-2 p-mb-2" iconPos="left" icon="pi pi-pencil" id="Edit"> </Button>
                    </router-link>
                    <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2" iconPos="left" icon="pi pi-trash"> </Button>
                </div><br><br> -->
                <!-- <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                    <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"> </Button>
                </div> -->
                <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                    <Button :label="$t('notice1.view.Back')" iconPos="left" icon="pi pi-replay" class="p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="margin-top: -26px; background: white; color: black"></Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import axios from 'axios';
import OtherPlatformService from '../../service/API/OtherPlatformService';
// import {useRouter} from 'vue-router'
import moment from 'moment';
export default {
    data() {
        return {
            hidefor: false,
            iconload: true,
            id: 414,
            employer_id: 7,
            background_pictures: [
                {
                    id: '',
                    type: '',
                    image_url: '',
                },
            ],
            created_at: '',
            company_profile_img: '',
            company_name: '',
            announcement_title: '',
            employer_rating: '',
            region_1st_depth: '',
            region_1st_depth_name: '',
            region_2nd_depth: '',
            region_2nd_depth_name: '',
            region_3rd_depth: '',
            region_3rd_depth_name: '',
            pay_type: '',
            education: '',
            gender: '',
            salary: '',
            work_type: '',
            working_period: '',
            working_days: [],
            working_hour_from: '',
            working_hour_end: '',
            break_time_from: '',
            break_time_end: '',
            career: '',
            min_experience: '',
            max_experience: '',
            occupations: [
                {
                    occupation_first: '',
                    occupation_second: '',
                    occupation_third: [],
                    occupation_first_txt: '',
                    occupation_second_txt: '',
                    occupation_third_txt: [],
                    name: [],
                },
            ],
            job_type: '',
            responsibilities: '',
            areas_of_recruitment: '',
            num_of_recruitment: '',
            age: '',
            mid_age_value: '',
            start_age: '',
            end_age: '',
            is_num_of_recruitment_undecided: '',
            preferential_conditions: [
                {
                    condition_type: '',
                    condiotion_direct_text: [],
                },
            ],
            preferential_conditions_txt: '',
            eligibilities: '',
            workarea_code: '',
            workarea_address: '',
            is_private_address: '',
            contact_name: '',
            is_private_name: '',
            contact_person_num: '',
            is_private_person_num: '',
            contact_email: '',
            is_private_email: '',
            no_of_emp: '',
            business_address: '',
            industry: '',
            status: '',
            notice_posting_period: '',
            notice_posting_period_custom_start_date: '',
            notice_posting_period_custom_end_date: '',
            lat: '',
            long: '',
            probation: '',
            negotiable_working_period: '',
            negotiable_working_days: '',
            no_break_time: '',
            prescribed_working_hours: '',
            updated_at: '',
            is_company_interest: '',
            interested_company_id: '',
            is_job_applied: '',
            is_scrap: '',
            scrap_id: '',
            // WeekendDays: ['월', '화', '수', '목', '금', '토', '일'],
            SystemTime: '',
            c_detail_address:'',
            job_detail_address:''
        };
    },
    created() {
        this.otherPlatformService = new OtherPlatformService();
        // this.detectTimeFormat();
        // // const timeFormat = detectTimeFormat();
        // this.SystemTime = this.detectTimeFormat();
        // console.log('Detected time format:', this.SystemTime);
    },
    methods: {
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD');
            }
        },
        formatSalary(value) {
            // Convert the value to a string and add comma separators
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        convertTo12HourFormat(timeString) {
            const date = new Date();
            const timeFormat = date.toLocaleTimeString();

            console.log(timeFormat);
            if (timeFormat.includes('AM') || timeFormat.includes('PM')) {
                const [hours, minutes] = timeString.split(':');
                let period = 'AM';

                let hour = parseInt(hours, 10);
                if (hour >= 12) {
                    period = 'PM';
                    if (hour > 12) {
                        hour -= 12;
                    }
                }

                return `${hour}:${minutes} ${period}`;
            } else {
                return `${timeString}`;
            }
        },

        // detectTimeFormat() {
        //     const now = new Date();
        //     const timeString = now.toLocaleTimeString();

        //     // Check for format indicators in the time string
        //     if (timeString.indexOf(':') !== -1) {
        //         // Format includes ':' separator, assuming 24-hour format
        //         return '24-hour';
        //     } else if (timeString.indexOf('AM') !== -1 || timeString.indexOf('PM') !== -1) {
        //         // Format includes 'AM' or 'PM', assuming 12-hour format
        //         return '12-hour';
        //     }

        //     // Unable to detect the format
        //     return 'unknown';
        // },
    },
    computed: {
        // weekdays() {
        //     // Map selected working days to their corresponding weekdays
        //     return this.working_days.map((day) => this.WeekendDays[day - 1]);
        // },
        getPreferentials() {
            return this.preferential_conditions.map((value) => value.condiotion_direct_text).join(' ');
            // console.log(this.hobbies)
        },
    },
    mounted() {
        this.otherPlatformService.viewOtherPost(this.$route.params.id).then((result) => {
            this.announcement_title = result.announcement_title;
            this.notice_posting_period = result.notice_posting_period;
            this.pay_type = result.pay_type;
            this.prescribed_working_hours = result.prescribed_working_hours;
            // if (this.SystemTime == '24-hour') {
            //     this.break_time_from = result.break_time_from;
            //     this.break_time_end = result.break_time_end;
            //     this.working_hour_from = result.working_hour_from;
            //     this.working_hour_end = result.working_hour_end;
            // } else {
            //     this.break_time_from = moment(result.break_time_from).format('h:mm A');
            //     this.break_time_end = moment(result.break_time_end).format('h:mm A');
            //     this.working_hour_from = moment(result.working_hour_from).format('h:mm A');
            //     this.working_hour_end = moment(result.working_hour_end).format('h:mm A');
            // }
            this.break_time_from = result.break_time_from;
            this.break_time_end = result.break_time_end;
            this.working_hour_from = result.working_hour_from;
            this.working_hour_end = result.working_hour_end;
            this.working_period = result.working_period;
            this.probation = result.probation;
            this.work_type = result.work_type;
            this.career = result.career;
            this.eligibilities = result.eligibilities;
            this.responsibilities = result.responsibilities;
            this.num_of_recruitment = result.num_of_recruitment;
            this.areas_of_recruitment = result.areas_of_recruitment;
            this.education = result.education;
            this.start_age = result.start_age;
            this.end_age = result.end_age;
            this.gender = result.gender;
            this.contact_name = result.contact_name;
            this.contact_email = result.contact_email;
            this.contact_person_num = result.contact_person_num;
            this.business_address = result.business_address;
            this.notice_posting_period_custom_start_date = result.notice_posting_period_custom_start_date;
            this.notice_posting_period_custom_end_date = result.notice_posting_period_custom_end_date;
            this.salary = result.salary;
            this.background_pictures = result.background_pictures;
            this.working_days = result.working_days;
            this.age = result.age;
            this.c_detail_address = result.c_detail_address;
            this.job_detail_address = result.job_detail_address;
            this.preferential_conditions = result.preferential_conditions.reduce((acc, curr) => {
                return acc.concat(curr.condiotion_direct_text);
            }, []);
            console.log(this.preferential_conditions);
            // this.occupations = result.occupations;
            this.occupations = result.occupations.reduce((acc, curr) => {
                return acc.concat(curr.name);
            }, []);
            // const allConditions = preferentialConditions.reduce((acc, curr) => {
            //     return acc.concat(curr.conditions);
            // }, []);
            // localStorage.setItem('desc', result[0].content);
            console.log(result);
            setTimeout(() => {
                this.iconload = false;
                this.hidefor = true;
            }, 1000);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}
/* .card.p-fluid {
    height: 100vh;
} */
.p-d-flex.p-jc-end.p-ai-center.dual-btn {
    margin-top: 13px;
}
button.p-button.p-component.p-button1.p-button-outlined.p-button-help.p-mr-2.p-mb-2 {
    background: black;
    color: white;
}
button.p-button.p-component.p-button-outlined.p-button-sm.p-mr-2.p-mb-2 {
    background: white;
    color: black;
    border: 1px solid;
}
#Edit {
    background: black;
    color: white;
}
.product-image {
    padding-top: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px;
    height: 100px;
    margin-left: 7px;
}
span#JS {
    padding: 5px;
    margin: 5px;
}
span#PC {
    padding: 5px;
    margin: 5px;
}
</style>
